var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"logo",attrs:{"src":_vm.logoUrl,"alt":"logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }